import { motion } from "framer-motion";
import { FaExternalLinkAlt, FaGithub } from 'react-icons/fa';
import Headline from "../shared/Headline";
import projectsData from "../project";

const container = {
  hidden: { opacity: 0 },
  show: {
    opacity: 1,
    transition: { staggerChildren: 0.1 },
  },
};

const item = {
  hidden: { opacity: 0, y: 30 },
  show: { opacity: 1, y: 0, transition: { duration: 0.5 } },
};

const Projects = () => {
  return (
    <section id="projects" className="px-6 relative">
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_bottom_left,rgba(168,85,247,0.05),transparent_60%)]" />
      <div className="container-custom relative">
        <Headline
          title="Featured Projects"
          subtitle="A selection of projects I've built with passion."
        />

        <motion.div
          variants={container}
          initial="hidden"
          whileInView="show"
          viewport={{ once: true, amount: 0.1 }}
          className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6"
        >
          {projectsData.map((project) => (
            <motion.div
              key={project.id}
              variants={item}
              className="group card-hover overflow-hidden rounded-2xl"
            >
              <div className="relative h-48 overflow-hidden rounded-t-2xl">
                <img
                  src={project.image}
                  alt={project.name}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
                />
                <div className="absolute inset-0 bg-gradient-to-t dark:from-dark-bg from-white via-transparent to-transparent opacity-60" />

                <div className="absolute top-3 right-3 flex gap-2 opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                  {project.sourceCodeLink && (
                    <a
                      href={project.sourceCodeLink}
                      target="_blank"
                      rel="noreferrer"
                      className="p-2.5 glass rounded-xl hover:bg-white/20 transition-all"
                      aria-label="View source code"
                    >
                      <FaGithub className="w-4 h-4 text-white" />
                    </a>
                  )}
                  {project.link && (
                    <a
                      href={project.link}
                      target="_blank"
                      rel="noreferrer"
                      className="p-2.5 glass rounded-xl hover:bg-white/20 transition-all"
                      aria-label="View live project"
                    >
                      <FaExternalLinkAlt className="w-4 h-4 text-white" />
                    </a>
                  )}
                </div>
              </div>

              <div className="p-5">
                <h3 className="text-lg font-bold text-white mb-2 group-hover:text-primary-400 transition-colors">
                  {project.name}
                </h3>
                <p className="text-sm text-gray-400 mb-4 line-clamp-2">
                  {project.description}
                </p>

                <div className="flex flex-wrap gap-2">
                  {project.techStack?.map((tech, i) => (
                    <span
                      key={i}
                      className="badge"
                    >
                      {tech.name}
                    </span>
                  ))}
                </div>
              </div>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </section>
  );
};

export default Projects;
